import { duration } from "@formant/core/model/duration";

export function formatDateTimeLocaleISO(date: Date): string {
    const timezoneOffset = new Date().getTimezoneOffset() * duration.minute;
    return new Date(date.getTime() - timezoneOffset).toISOString().slice(0, -1);
}
